import React from 'react';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';

export default function Header({ name = '', isByoc = false, carrierId = '' }) {
  return (
    <div className={styles.carrier}>
      <div className={styles.row}>
        <strong>{name}</strong>
        <If test={isByoc}>
          <UiKit.Badge>Your Carrier Account</UiKit.Badge>
        </If>
      </div>
      <span className={styles.carrierId}>{carrierId}</span>
    </div>
  );
}
